import React from "react";
import localeText from "../../../../locale";
import LandingPlansCards from "../LandingPlansCards/LandingPlansCards";

function LandingPlans() {
  const featuresCard1 = [
    localeText("featureShowcase"),
    localeText("featureEconomicNetwork"),
    localeText("noMonthlyPayments"),
  ];

  const featuresCard2 = [
    localeText("featureEcommerce"),
    localeText("featureEconomicNetwork"),
    localeText("noMonthlyPayments"),
  ];

  const featuresCard3 = [
    localeText("featureOnlineStore"),
    localeText("featureGeolocation"),
    localeText("featureEvrythingIncluded"),
    localeText("noMonthlyPayments"),
  ];

  return (
    <section className="bg-white py-8" id="plans">
      <div className="grid align-items-end mb-3">
        <div className="flex flex-column gap-2 col-12 lg:col-8">
          <div className="eyebrow-text">{localeText("lp2PlansEyebrow")}</div>
          <div
            className="font-bold text-4xl md:text-5xl line-height-2 title"
            style={{ color: "var(--extra-green)" }}
          >
            {localeText("lp2PlansTitle")}
          </div>
          <div className="text-lg mt-2" style={{ color: "var(--extra-body)", maxWidth: "58ch" }}>
            {localeText("lp2PlansDescription")}
          </div>
        </div>
        <div className="col-12 lg:col-4">
          <div
            className="flex align-items-start gap-3 p-3 border-round-lg mt-4 lg:mt-0"
            style={{ backgroundColor: "rgba(62, 139, 92, 0.06)" }}
          >
            <i
              className="pi pi-verified mt-1"
              style={{ color: "var(--extra-green)", fontSize: "1.3rem" }}
            ></i>
            <div>
              <div className="font-bold text-sm" style={{ color: "var(--extra-green)" }}>
                {localeText("lp2PlansCalloutTitle")}
              </div>
              <div className="text-sm mt-1" style={{ color: "var(--extra-body)" }}>
                {localeText("lp2PlansCalloutDesc")}
              </div>
            </div>
          </div>
        </div>
      </div>

      <LandingPlansCards
        featuresCard1={featuresCard1}
        featuresCard2={featuresCard2}
        featuresCard3={featuresCard3}
      />
    </section>
  );
}

export default LandingPlans;
